<div class="body_bg">
  <frontend-artist-header></frontend-artist-header>
  <section class="delete_account_section">
    <div class="container">
      <div class="row justify-content-center mt-sm-0 mt-5">

        <div class="col-12 col-md-6 col-lg-5 mb-4" *ngIf="showFindAccount">
          <div class="delete-card">
            <h2 class="card-title mb-3">Delete Account</h2>
            <div class="caution-text mb-3">
              <strong>Caution:</strong> This will delete all your account information, including your third party logins, billing and bank details, and any other content created by you on our platform. This action cannot be reversed.
            </div>
            <div class="name_inputfield mb-3">
              <input
                type="email"
                class="form-control"
                [(ngModel)]="email"
                placeholder="youremail@example.com"
              />
            </div>
            <button class="btn-action" (click)="findAccount()">
              Find Account
            </button>
          </div>
        </div>

        <div class="col-12 col-md-7 mb-4" *ngIf="showReasonCard">
          <div class="delete-card">
            <div class="account-info mb-3">
              <strong>Account:</strong> {{ accountUsername ? accountName + ' (' + accountUsername + ')' : accountName }}
            </div>
            <label class="reason-label">Enter your reason</label>
            <textarea
              class="form-control reason-textarea mb-3"
              [(ngModel)]="reason"
              rows="5"
            ></textarea>
            <div class="button-group d-flex flex-wrap gap-2 align-items-center">
              <a routerLink="/contact-us" class="btn-action">
                Help
              </a>
              <button class="btn-action" (click)="sendVerification()">
                Send OTP/Verification Link
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-12 col-md-6 col-lg-5 mb-4" *ngIf="showVerificationCard">
          <div class="delete-card">
            <h2 class="card-title">Two-Factor Verification</h2>
            <p class="caution-text">Please enter the code sent to your email.</p>
              <div class="name_inputfield mb-3">
                <div class="row">
                  <div class="col-2 pe-2">
                    <input
                      #input1
                      (input)="moveToNext($event, 1)"
                      [(ngModel)]="code1"
                      class="code-input"
                      maxlength="1"
                      type="text"
                    />
                  </div>
                  <div class="col-2 px-2">
                    <input
                      #input2
                      (input)="moveToNext($event, 2)"
                      [(ngModel)]="code2"
                      class="code-input"
                      maxlength="1"
                      type="text"
                    />
                  </div>

                  <div class="col-2 px-2">
                    <input
                      #input3
                      (input)="moveToNext($event, 3)"
                      [(ngModel)]="code3"
                      class="code-input"
                      maxlength="1"
                      type="text"
                    />
                  </div>
                  <div class="col-2 px-2">
                    <input
                      #input4
                      (input)="moveToNext($event, 4)"
                      [(ngModel)]="code4"
                      class="code-input"
                      maxlength="1"
                      type="text"
                    />
                  </div>
                  <div class="col-2 px-2">
                    <input
                      #input5
                      (input)="moveToNext($event, 5)"
                      [(ngModel)]="code5"
                      class="code-input"
                      maxlength="1"
                      type="text"
                    />
                  </div>
                  <div class="col-2 px-2">
                    <input
                      #input6
                      (input)="moveToNext($event, 6)"
                      [(ngModel)]="code6"
                      class="code-input"
                      maxlength="1"
                      type="text"
                    />
                  </div>
                </div>

            </div>
            <div class="button-group d-flex">
              <a routerLink="/" class="btn-action me-2">
                Cancel
              </a>
              <button class="btn-action" (click)="confirm()">
                Confirm
              </button>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-5 mb-4" *ngIf="showSuccessCard">
          <div class="delete-card">
            <div class="success-banner">
              <span class="checkmark">✓</span>
              <strong>You have been signed out from all sessions</strong>
            </div>
            <div class="caution-text">
              <strong>We have staged your account to be deleted in 30 days.</strong>
            </div>
            <p class="caution-text">
              If there's no login activity in 30 days from you, your account will be deleted.
              If you decide to login in between 30 days, deletion will be cancelled.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="container footer-section">
    <frontend-artist-footer></frontend-artist-footer>
  </div>
</div>
